import { render, staticRenderFns } from "./Tis.vue?vue&type=template&id=53623a4c&lang=pug&"
import script from "./Tis.vue?vue&type=script&lang=ts&"
export * from "./Tis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports